import { useSession } from 'next-auth/react';
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { followedSeriesData } from 'redux/actions/seriesAction';

function FollowButton({show , size , setLoginPrompt}) {

    const [showData , setShowData] = useState(show)
    const { userLocalDetail } = useSelector(({ AuthReducer }) => AuthReducer);
    const { data: session } = useSession();
    
    

    const dispatch = useDispatch()

       //handle follow click
       const handleFollowed = (_id, postSlug, title) => {
        if (userLocalDetail?.id || session?.user?.email) {
            const type = 'video';
            dispatch(followedSeriesData({ _id, type, postSlug }));

            

            setShowData({
                ...showData,
                isFollowed : showData?.isFollowed ? false   : true
            })
        } else {
            setLoginPrompt(true);
        }
    };
  return (
    <div>
           <button onClick={() => {
                handleFollowed(
                    showData?._id,
                    showData?.postSlug,
                    showData?.title
                );
            }} className='btn m-0 p-0 py-1 d-flex justify-content-center gap-2 align-items-center'
                style={{
                    cursor: "pointer",
                    border: "2px solid #D8358A",
                    color: showData?.isFollowed ? "white" : "#D8358A",
                    backgroundColor: !showData?.isFollowed ? "white" : "#D8358A",
                    fontSize: size.width < 1000 ? "12px" : "14.75px", fontWeight: "500"
                }}>
                {!showData?.isFollowed ?
                    <svg width="21" height="20" viewBox="0 0 21 20" fill={showData?.isFollowed ? "white" : "#D8358A"} xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.95633 0.00146484H15.1177C18.4563 0.00146484 20.3612 1.88677 20.3612 5.23514V14.4063C20.3612 17.7351 18.4661 19.64 15.1275 19.64H5.95633C2.60796 19.64 0.722656 17.7351 0.722656 14.4063V5.23514C0.722656 1.88677 2.60796 0.00146484 5.95633 0.00146484ZM11.3464 10.6359H14.135C14.5867 10.6261 14.95 10.2627 14.95 9.81105C14.95 9.35937 14.5867 8.99605 14.135 8.99605H11.3464V6.22702C11.3464 5.77533 10.983 5.41202 10.5314 5.41202C10.0797 5.41202 9.71635 5.77533 9.71635 6.22702V8.99605H6.9375C6.72147 8.99605 6.51527 9.08443 6.35816 9.23172C6.21087 9.38883 6.1225 9.59405 6.1225 9.81105C6.1225 10.2627 6.48581 10.6261 6.9375 10.6359H9.71635V13.4147C9.71635 13.8664 10.0797 14.2297 10.5314 14.2297C10.983 14.2297 11.3464 13.8664 11.3464 13.4147V10.6359Z" fill={showData?.isFollowed ? "white" : "#D8358A"} />
                    </svg> :
                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.1378 1.87H7.30247C3.89907 1.87 1.87012 3.89895 1.87012 7.30235V15.1283C1.87012 18.541 3.89907 20.57 7.30247 20.57H15.1284C18.5318 20.57 20.5608 18.541 20.5608 15.1376V7.30235C20.5701 3.89895 18.5412 1.87 15.1378 1.87ZM15.6894 9.0695L10.388 14.3709C10.2571 14.5018 10.0794 14.5766 9.89242 14.5766C9.70542 14.5766 9.52777 14.5018 9.39687 14.3709L6.75082 11.7249C6.47967 11.4537 6.47967 11.0049 6.75082 10.7338C7.02197 10.4626 7.47077 10.4626 7.74192 10.7338L9.89242 12.8843L14.6983 8.0784C14.9695 7.80725 15.4183 7.80725 15.6894 8.0784C15.9606 8.34955 15.9606 8.789 15.6894 9.0695Z" fill="white" />
                    </svg>
                }

                {showData?.isFollowed ? "फ़ॉलोड" : "फॉलो करें"}
            </button>
    </div>
  )
}

export default FollowButton
